import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import VideoFeed from "./components/VideoFeed";
import About from "./components/About";
import "./App.css"; // make sure your CSS file is imported

function App() {
  return (
    <Router>
      <div className="app-container">
        <Routes>
          <Route path="/" element={<VideoFeed />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
